<template lang="pug">
.discontinuedParts
    v-container
        v-row
            v-col
                .text-h5.black--text Discontinued Parts
            v-spacer
            v-col.flex-grow-0.flex-shrink-1
                v-btn.white--text(color='brand', @click='discontinueDialog=true') Discontinue Part
        v-row
            v-col
                v-data-table(:loading='fetchingDiscontinuedParts', :items='discontinuedParts', :headers='discontinuedHeaders', :footer-props="{'items-per-page-options':[20]}", dense, height='75vh')
                    template(v-slot:item.last_sold_date='{item, value}')
                        span {{ getPrettyDate(value) }}
                    template(v-slot:item.undo='{item, value}')
                        v-btn(icon, color='red', @click='prepareForRemove(item)')
                            v-icon close
    v-dialog(v-model='discontinueDialog', max-width='750')
        v-card(light)
            v-card-title Search Parts to Discontinue
            v-card-text
                v-row
                    v-col
                        v-text-field(v-model='searchString', dense, outlined, color='brand', label='Search', :loading='fetchingParts', @keyup='handlePartSearchInput')
                v-row
                    v-col
                        v-data-table(:loading='fetchingParts', :items='parts', :headers='headers', :footer-props="{'items-per-page-options':[20]}", :items-per-page.sync='itemsPerPage', dense, :page.sync='currentPageNumber', :server-items-length='totalItems', height='50vh')
                            template(v-slot:item.discontinue='{item, value}')
                                v-tooltip(left)
                                    template(v-slot:activator="{on, attrs}")
                                        v-btn(icon, v-on='on')
                                            v-icon(@click='discontinuePart(item)' color='red') archive
                                    span This action will set this part as "discontinued".
    v-dialog(v-model='undoDialog' max-width='500')
        v-card(light)
            v-card-title Remove
            v-card-text Remove this part from discontinued list?
            v-card-actions
                v-spacer
                v-btn(text, @click='undoDialog=false') Cancel
                v-btn.white--text(color='brand', @click='removePart') Remove

</template>
<script>
import {debounce} from 'lodash';

export default {
    props: {},
    data () {
        return {
            discontinueDialog: false,
            undoDialog: false,
            fetchingParts: false,
            fetchingDiscontinuedParts: true,
            itemsPerPage: 20,
            currentPageNumber: 1,
            searchString: '',
            totalItems: 0,
            parts: [],
            discontinuedParts: [],
            discontinuedHeaders: [
                {
                    text: 'Product ID',
                    value: 'product_id'
                },
                {
                    text: 'Jonas Description',
                    value: 'description'
                },
                {
                    text: 'Custom Description',
                    value: 'custom_description'
                },
                {
                    text: 'Tacking Code',
                    value: 'tracking_code'
                },
                {
                    text: 'Last Sold',
                    value: 'last_sold_date'
                },
                {
                    text: 'Restore',
                    value: 'undo'
                }
            ],
            headers: [
                {
                    text: 'Product ID',
                    value: 'product_id'
                },
                {
                    text: 'Jonas Description',
                    value: 'description'
                },
                {
                    text: 'Custom Description',
                    value: 'custom_description'
                },
                {
                    text: '',
                    value: 'discontinue'
                }
            ],
            partToRemove: null
        };
    },
    methods: {
        fetchParts: debounce(async function () {
            this.fetchingParts = true;
            const requestData = {
                terms: this.searchString.toLowerCase().split(' '),
                offset: (this.currentPageNumber - 1) * this.itemsPerPage,
                limit: this.itemsPerPage
            };
            const searchResults = await this.sendCommand({
                action: 'searchParts',
                parameters: requestData
            });
            this.parts = searchResults.parts;
            this.totalItems = searchResults.count;
            this.fetchingParts = false;
        }, 500),
        fetchDiscontinuedParts: debounce(async function () {
            this.fetchingDiscontinuedParts = true;
            const results = await this.sendCommand({
                action: 'getDiscontinuedParts',
            });
            this.discontinuedParts = results;
            this.fetchingDiscontinuedParts = false;
        }),
        handlePartSearchInput (event) {
            this.fetchingParts = true;
            this.fetchParts(event.target.value);
            this.currentPageNumber = 1;
        },
        getPrettyDate (dateString) {
            const date = new Date(dateString);
            return date.toLocaleDateString();
        },
        prepareForRemove (part) {
            this.partToRemove = part;
            this.undoDialog = true;
        },
        async removePart () {
            await this.sendCommand({
                action: 'setDiscontinuedPart',
                parameters: {
                    partId: this.partToRemove.id,
                    discontinued: false
                }
            });
            await this.fetchDiscontinuedParts();
            this.partToRemove = null;
            this.undoDialog = false;
        },
        async discontinuePart (part) {
            await this.sendCommand({
                action: 'setDiscontinuedPart',
                parameters: {
                    partId: part.id,
                    discontinued: true
                }
            });
            this.discontinueDialog = false;
            await this.fetchDiscontinuedParts();
        }
    },
    watch: {
        itemsPerPage () {
            this.fetchingParts = true;
            this.fetchParts();
        },
        currentPageNumber () {
            this.fetchingParts = true;
            this.fetchParts();
        }
    },
    mounted () {
        this.fetchDiscontinuedParts();
    }
};
</script>
